import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';

import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: (props) => ({
    //// NOTE
    //// adding bg color to the logo does not give the expected result
    //// that's why is commented out
    // backgroundColor: props.backgroundColor,
    objectFit: 'contain',
    '& span': {
      padding: props.padding,
      [theme.breakpoints.up('xs')]: {
        height: `calc(100px + ${props.padding})`,
      },
      [theme.breakpoints.down('xs')]: {
        height: '100%',
      },
    },
    '& img': {
      [theme.breakpoints.down('xs')]: {
        maxWidth: '100%',
      },
    },
  }),
  media: {
    objectFit: 'contain',
  },
}));

const Logo = ({ src, title, logoPadding, backgroundColor }) => {
  const props = { padding: logoPadding, backgroundColor: backgroundColor };
  const classes = useStyles(props);

  return (
    <div className={classes.root}>
      {src && (
        <LazyLoadImage
          style={{
            maxHeight: `calc(100px + ${logoPadding})`,
          }}
          alt={title}
          src={src}
          effect='blur'
        />
      )}
    </div>
  );
};

export default Logo;
